import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["onSelectItem", "selected", "value"],
  _excluded2 = ["items", "onSelectItem", "onDismiss"],
  _excluded3 = ["buttons"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { f, d, b, c } from './chunk-XVC7DH25.js';
import { DEFAULT_STATE, PlayerState } from '@dotlottie/common';
import i, { useCallback, useMemo, useState, useEffect, useRef } from 'react';
var we = function we() {};
function C(t) {
  var n = f(),
    e = useCallback(function () {
      if (n !== null) return t(n.getState());
    }, [t, n]),
    c = useCallback(function (s) {
      return n === null ? we : n.state.subscribe(s);
    }, [n]);
  return d(c, e, function () {
    return t(DEFAULT_STATE);
  });
}
var U = function U(t) {
  return i.createElement("svg", _objectSpread({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), i.createElement("path", {
    d: "M8.33325 11.6667C7.78097 11.6667 7.33325 12.1144 7.33325 12.6667C7.33325 13.2189 7.78097 13.6667 8.33325 13.6667C8.88554 13.6667 9.33325 13.2189 9.33325 12.6667C9.33325 12.1144 8.88554 11.6667 8.33325 11.6667Z",
    fill: "currentColor"
  }), i.createElement("path", {
    d: "M7.33325 8C7.33325 7.44771 7.78097 7 8.33325 7C8.88554 7 9.33325 7.44771 9.33325 8C9.33325 8.55228 8.88554 9 8.33325 9C7.78097 9 7.33325 8.55228 7.33325 8Z",
    fill: "currentColor"
  }), i.createElement("path", {
    d: "M7.33325 3.33333C7.33325 2.78105 7.78097 2.33333 8.33325 2.33333C8.88554 2.33333 9.33325 2.78105 9.33325 3.33333C9.33325 3.88562 8.88554 4.33333 8.33325 4.33333C7.78097 4.33333 7.33325 3.88562 7.33325 3.33333Z",
    fill: "currentColor"
  }));
};
var $ = function $(t) {
  return i.createElement("svg", _objectSpread({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), i.createElement("path", {
    d: "M10.8654 2.31311C11.0607 2.11785 11.3772 2.11785 11.5725 2.31311L13.4581 4.19873C13.6534 4.39399 13.6534 4.71058 13.4581 4.90584L11.5725 6.79146C11.3772 6.98672 11.0607 6.98672 10.8654 6.79146C10.6701 6.5962 10.6701 6.27961 10.8654 6.08435L11.6162 5.33354H4V6.66687C4 7.03506 3.70152 7.33354 3.33333 7.33354C2.96514 7.33354 2.66666 7.03506 2.66666 6.66687L2.66666 4.66687C2.66666 4.29868 2.96514 4.0002 3.33333 4.0002H11.8454L10.8654 3.02022C10.6701 2.82496 10.6701 2.50838 10.8654 2.31311Z",
    fill: "currentColor"
  }), i.createElement("path", {
    d: "M12.4375 11.9998C12.8057 11.9998 13.1042 11.7013 13.1042 11.3331V9.33313C13.1042 8.96494 12.8057 8.66647 12.4375 8.66647C12.0693 8.66647 11.7708 8.96494 11.7708 9.33313V10.6665H4.15462L4.90543 9.91565C5.10069 9.72039 5.10069 9.40381 4.90543 9.20854C4.71017 9.01328 4.39359 9.01328 4.19832 9.20854L2.31271 11.0942C2.11744 11.2894 2.11744 11.606 2.31271 11.8013L4.19832 13.6869C4.39359 13.8821 4.71017 13.8821 4.90543 13.6869C5.10069 13.4916 5.10069 13.175 4.90543 12.9798L3.92545 11.9998H12.4375Z",
    fill: "currentColor"
  }));
};
var z = function z(t) {
  return i.createElement("svg", _objectSpread({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3336 2.5C14.3336 2.22386 14.1097 2 13.8336 2C13.5574 2 13.3336 2.22386 13.3336 2.5V13.5C13.3336 13.7761 13.5574 14 13.8336 14C14.1097 14 14.3336 13.7761 14.3336 13.5V2.5ZM3.50618 2.21722C2.83954 1.82595 2 2.30667 2 3.07965V12.9201C2 13.6931 2.83954 14.1738 3.50618 13.7825L11.8893 8.86231C12.5477 8.47586 12.5477 7.52389 11.8893 7.13745L3.50618 2.21722Z",
    fill: "currentColor"
  }));
};
var O = function O(t) {
  return i.createElement("svg", _objectSpread({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), i.createElement("path", {
    d: "M3.99996 2C3.26358 2 2.66663 2.59695 2.66663 3.33333V12.6667C2.66663 13.403 3.26358 14 3.99996 14H5.33329C6.06967 14 6.66663 13.403 6.66663 12.6667V3.33333C6.66663 2.59695 6.06967 2 5.33329 2H3.99996Z",
    fill: "currentColor"
  }), i.createElement("path", {
    d: "M10.6666 2C9.93025 2 9.33329 2.59695 9.33329 3.33333V12.6667C9.33329 13.403 9.93025 14 10.6666 14H12C12.7363 14 13.3333 13.403 13.3333 12.6667V3.33333C13.3333 2.59695 12.7363 2 12 2H10.6666Z",
    fill: "currentColor"
  }));
};
var j = function j(t) {
  return i.createElement("svg", _objectSpread({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), i.createElement("path", {
    d: "M3.33337 3.46787C3.33337 2.52312 4.35948 1.93558 5.17426 2.41379L12.8961 6.94592C13.7009 7.41824 13.7009 8.58176 12.8961 9.05408L5.17426 13.5862C4.35948 14.0644 3.33337 13.4769 3.33337 12.5321V3.46787Z",
    fill: "currentColor"
  }));
};
var Q = function Q(t) {
  return i.createElement("svg", _objectSpread({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.69214 13.5C1.69214 13.7761 1.916 14 2.19214 14C2.46828 14 2.69214 13.7761 2.69214 13.5L2.69214 2.5C2.69214 2.22386 2.46828 2 2.19214 2C1.916 2 1.69214 2.22386 1.69214 2.5V13.5ZM12.5192 13.7828C13.1859 14.174 14.0254 13.6933 14.0254 12.9204L14.0254 3.0799C14.0254 2.30692 13.1859 1.8262 12.5192 2.21747L4.13612 7.13769C3.47769 7.52414 3.47769 8.4761 4.13612 8.86255L12.5192 13.7828Z",
    fill: "currentColor"
  }));
};
var Y = function Y(t) {
  return i.createElement("svg", _objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5303 6.46967C13.8232 6.76256 13.8232 7.23744 13.5303 7.53033L9.06066 12L13.5303 16.4697C13.8232 16.7626 13.8232 17.2374 13.5303 17.5303C13.2374 17.8232 12.7626 17.8232 12.4697 17.5303L7.46967 12.5303C7.17678 12.2374 7.17678 11.7626 7.46967 11.4697L12.4697 6.46967C12.7626 6.17678 13.2374 6.17678 13.5303 6.46967Z",
    fill: "currentColor"
  }));
};
var ee = function ee(t) {
  return i.createElement("svg", _objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4697 17.5303C10.1768 17.2374 10.1768 16.7626 10.4697 16.4697L14.9393 12L10.4697 7.53033C10.1768 7.23744 10.1768 6.76256 10.4697 6.46967C10.7626 6.17678 11.2374 6.17678 11.5303 6.46967L16.5303 11.4697C16.8232 11.7626 16.8232 12.2374 16.5303 12.5303L11.5303 17.5303C11.2374 17.8232 10.7626 17.8232 10.4697 17.5303Z",
    fill: "currentColor"
  }));
};
var te = function te(_ref) {
  var t = _ref.children,
    n = _ref.enableReset,
    _ref$expand = _ref.expand,
    e = _ref$expand === void 0 ? !1 : _ref$expand,
    c = _ref.onBack,
    a = _ref.onExpand,
    s = _ref.onReset,
    m = _ref.title;
  var d = useCallback(function () {
      c();
    }, [c]),
    x = useCallback(function () {
      a();
    }, [a]),
    h = useCallback(function () {
      s();
    }, [s]);
  return i.createElement(i.Fragment, null, !e && i.createElement("button", {
    className: "popover-item",
    "aria-label": "Go to ".concat(m),
    onClick: x
  }, i.createElement("span", {
    style: {
      flex: 1
    }
  }, m), i.createElement("span", null, i.createElement(ee, null))), e && i.createElement("div", {
    className: "popover-submenu"
  }, i.createElement("div", {
    className: "popover-header"
  }, i.createElement("button", {
    onClick: d
  }, i.createElement(Y, null)), i.createElement("div", {
    className: "popover-header-title",
    style: {
      flex: 1
    }
  }, i.createElement("span", null, m), n && i.createElement("button", {
    className: "reset-theme",
    onClick: h,
    "aria-label": "Reset ".concat(m)
  }, "Reset"))), t));
};
var ne = function ne(t) {
  return i.createElement("svg", _objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5283 5.9372C20.8211 6.23009 20.8211 6.70497 20.5283 6.99786L9.4631 18.063C9.32181 18.2043 9.12997 18.2833 8.93016 18.2826C8.73035 18.2819 8.53907 18.2015 8.39877 18.0593L3.46807 13.0596C3.17722 12.7647 3.18052 12.2898 3.47544 11.999C3.77036 11.7081 4.24522 11.7114 4.53608 12.0063L8.93646 16.4683L19.4676 5.9372C19.7605 5.64431 20.2354 5.64431 20.5283 5.9372Z",
    fill: "currentColor"
  }));
};
var re = function re(_ref2) {
  var t = _ref2.onSelectItem,
    _ref2$selected = _ref2.selected,
    n = _ref2$selected === void 0 ? !1 : _ref2$selected,
    e = _ref2.value,
    c = _objectWithoutProperties(_ref2, _excluded);
  var a = useCallback(function () {
    t == null || t(e);
  }, [t, e]);
  return i.createElement("button", _objectSpread({
    "aria-label": "Select ".concat(e),
    className: "popover-item ".concat(n ? "selected" : ""),
    onClick: a
  }, c), i.createElement("span", {
    style: {
      visibility: n ? "visible" : "hidden"
    }
  }, i.createElement(ne, null)), i.createElement("span", {
    style: {
      flex: 1
    }
  }, e));
};
var se = function se(_ref3) {
  var _ref3$items = _ref3.items,
    t = _ref3$items === void 0 ? [] : _ref3$items,
    n = _ref3.onSelectItem,
    e = _ref3.onDismiss,
    c$1 = _objectWithoutProperties(_ref3, _excluded2);
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    a = _useState2[0],
    s = _useState2[1],
    m = useRef(null);
  b(m, function () {
    s(""), e();
  }), c("Escape", function () {
    s(""), e();
  });
  var d = useCallback(function () {
      s("");
    }, [s]),
    x = useCallback(function (r) {
      return function () {
        return s(r);
      };
    }, [s]),
    h = useCallback(function (r, v) {
      return function () {
        return n(r, v);
      };
    }, [n]);
  return i.createElement("dialog", _objectSpread({
    ref: m,
    style: {
      padding: a ? "0px" : "8px"
    },
    className: "popover",
    "aria-label": "Popover Menu"
  }, c$1), i.createElement("ul", {
    "aria-label": "Popover content",
    className: "popover-content"
  }, t.map(function (r) {
    return i.createElement("li", {
      key: r.title,
      style: {
        width: "100%"
      }
    }, (a === r.title || !a) && i.createElement(te, {
      expand: a === r.title,
      title: r.title,
      onExpand: x(r.title),
      onBack: d,
      enableReset: r.enableReset,
      onReset: h(r.title, "")
    }, i.createElement("ul", {
      className: "popover-items",
      "aria-label": "List of ".concat(r.title)
    }, r.items.map(function (v) {
      return i.createElement("li", {
        key: v.value
      }, i.createElement(re, {
        value: v.value,
        selected: v.selected,
        onSelectItem: h(r.title, v.value)
      }));
    }))));
  })));
};
var ke = ["play", "stop", "loop", "next", "previous", "animations", "themes"],
  S3 = function S3(_ref4) {
    var _ref4$buttons = _ref4.buttons,
      t = _ref4$buttons === void 0 ? ke : _ref4$buttons,
      n = _objectWithoutProperties(_ref4, _excluded3);
    var e = f(),
      c = C(function (o) {
        return o.loop;
      }),
      a = C(function (o) {
        return o.currentState;
      }),
      s = C(function (o) {
        return o.seeker;
      }),
      m = C(function (o) {
        return o.currentAnimationId;
      }),
      d = C(function (o) {
        return o.defaultTheme;
      }),
      x = C(function (o) {
        return o.direction;
      }),
      h = C(function (o) {
        return o.activeStateId;
      }),
      r = useMemo(function () {
        return a === PlayerState.Playing;
      }, [a]),
      _useState3 = useState(!1),
      _useState4 = _slicedToArray(_useState3, 2),
      v = _useState4[0],
      A = _useState4[1],
      _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      b = _useState6[0],
      ie = _useState6[1],
      _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      V = _useState8[0],
      le = _useState8[1],
      _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      B = _useState10[0],
      ae = _useState10[1],
      H = useMemo(function () {
        var o = [],
          u = b.map(function (l) {
            return {
              value: l.id,
              selected: m === l.id
            };
          }),
          S = V.filter(function (l) {
            return l.animations.length === 0 || l.animations.includes(m || "");
          }).map(function (l) {
            return {
              value: l.id,
              selected: d === l.id
            };
          }),
          w = B.map(function (l) {
            return {
              value: l,
              selected: h === l
            };
          });
        return Array.isArray(u) && u.length !== 0 && o.push({
          title: "Animations",
          items: u,
          enableReset: !1
        }), Array.isArray(w) && w.length !== 0 && o.push({
          title: "States",
          items: w,
          enableReset: !0
        }), Array.isArray(S) && S.length !== 0 && o.push({
          title: "Themes",
          items: S,
          enableReset: !!d
        }), o;
      }, [b, V, m, d, B, h]),
      pe = useMemo(function () {
        return t.includes("themes") && Array.isArray(V) && V.length ? !0 : t.includes("animations") && Array.isArray(b) && b.length > 1;
      }, [H]),
      me = useCallback(function () {
        A(!v);
      }, [A]),
      ue = useCallback(function () {
        A(!1);
      }, [A]),
      ce = useCallback(function () {
        e == null || e.toggleLoop();
      }, [e]),
      ve = useCallback(function () {
        e == null || e.freeze();
      }, [e]),
      fe = useCallback(function () {
        e == null || e.unfreeze();
      }, [e]),
      Ce = useCallback(function () {
        e == null || e.next();
      }, [e]),
      de = useCallback(function () {
        e == null || e.previous();
      }, [e]),
      he = useCallback(function () {
        e == null || e.togglePlay();
      }, [e]),
      ge = useCallback(function (o, u) {
        o === "Animations" && (e == null || e.play(u)), o === "Themes" && (e == null || e.setDefaultTheme(u)), o === "States" && (u ? e == null || e.enterInteractiveMode(u) : e == null || e.exitInteractiveMode());
      }, [e]),
      be = useCallback(function (o) {
        e == null || e.seek(String(o.currentTarget.value).concat("%"));
      }, [e]);
    function D() {
      var w, l, Z;
      var o = (w = e == null ? void 0 : e.getManifest()) == null ? void 0 : w.animations,
        u = (l = e == null ? void 0 : e.getManifest()) == null ? void 0 : l.themes,
        S = (Z = e == null ? void 0 : e.getManifest()) == null ? void 0 : Z.states;
      o && ie(o), u && le(u), S && ae(S);
    }
    return useEffect(function () {
      if (!(typeof e > "u")) return e == null || e.addEventListener("DOMLoaded", D), function () {
        e == null || e.removeEventListener("DOMLoaded", D);
      };
    }, [e]), i.createElement("div", _objectSpread({
      "aria-label": "lottie-animation-controls",
      className: "toolbar"
    }, n), t.includes("previous") && b.length > 1 && i.createElement("button", {
      onClick: de,
      "aria-label": "play-previous"
    }, i.createElement(Q, null)), t.includes("play") && i.createElement("button", {
      onClick: he,
      "aria-label": "play-pause"
    }, r ? i.createElement(O, null) : i.createElement(j, null)), t.includes("next") && b.length > 1 && i.createElement("button", {
      onClick: Ce,
      "aria-label": "play-next"
    }, i.createElement(z, null)), i.createElement("input", {
      style: {
        width: "100%",
        "--seeker": s
      },
      className: "seeker ".concat(x === 1 ? "" : "to-left"),
      type: "range",
      min: 0,
      step: 0,
      max: 100,
      value: s || 0,
      onInput: be,
      onMouseDown: ve,
      onMouseUp: fe,
      "aria-valuemin": 1,
      "aria-valuemax": 100,
      role: "slider",
      "aria-valuenow": s,
      "aria-label": "lottie-seek-input"
    }), t.includes("loop") && i.createElement("button", {
      onClick: ce,
      className: c ? "active" : "",
      "aria-label": "loop-toggle"
    }, i.createElement($, null)), pe && i.createElement("div", {
      style: {
        position: "relative"
      }
    }, i.createElement(se, {
      items: H,
      open: v,
      onDismiss: ue,
      onSelectItem: ge
    }), i.createElement("button", {
      className: "".concat(v ? "popover-active" : ""),
      "aria-label": "open-popover",
      onClick: me
    }, i.createElement(U, null))));
  };
export { C as a, S3 as b };